export const COLUMN_ORDER = "1fr 9rem";
